import React from "react";
import { IField } from "../../interfaces/Components/Field/IField";

import './Field.scss';

export const Field: React.FC<IField> = ({ label, data, ...props }) => {

    const className = `field ${props.className || ''}`;
    return (
        <div className={className}>
            <span className="label">{`${label}:`}</span>
            <span className="data">{data}</span>
        </div>
    );

}

